import { ArrowPathIcon, PhotoIcon } from "@heroicons/react/24/outline";
import { useEffect, useState } from "react";
import { ContentRow } from "../../api/content.type";
import {
  useRegenerateImages,
  useRegenerateText,
} from "../../hooks/useRegenerateContent";
import useUserDetails from "../../hooks/useUserDetails";
import { SubmitButton } from "../shared/buttons/submit-button";

export default function ContentActions({ content }: { content: ContentRow }) {
  const { mutate: regenImages, isPending: imagesPending } =
    useRegenerateImages();
  const { mutate: regenText, isPending: textPending } = useRegenerateText();

  const [hasImages, setHasImages] = useState(false);
  const { userDetails } = useUserDetails();
  const isAdmin = userDetails?.type === "admin";

  useEffect(() => {
    if (content.text) {
      const foundImages = content.text.match(/!\[.*?\]\((.*?)\)/g);
      if (foundImages) {
        setHasImages(true);
      }
    }
  }, [content.text]);

  return (
    <div className="flex gap-2 absolute top-10 right-5">
      {!hasImages && isAdmin && (
        <SubmitButton
          icon={<PhotoIcon className="w-4 h-4" color="white" />}
          size="sm"
          iconOnly
          isLoading={imagesPending}
          onClick={() => regenImages(content.id)}
          aria-label="Regenerate images"
        />
      )}
      {isAdmin && (
        <SubmitButton
          icon={<ArrowPathIcon className="w-4 h-4" color="white" />}
          size="sm"
          iconOnly
          isLoading={textPending}
          onClick={() => regenText(content.id)}
          aria-label="Regenerate text"
        />
      )}
    </div>
  );
}
